<template>

  <div class="main-content container-fluid">
    <div class="row">
      <div class="col-md-12">
        <Panel class="panel panel-default panel-border-color panel-border-color-primary">
          <PanelHeading title="Lecture notes imported" subtitle="Your notes were imported successfully. Where to now?"></PanelHeading>
          <PanelBody>
            <div class="row ptb-50">
              <div class="col-xs-12">
                <router-link :to="{name: 'subject-shelf'}" class="btn btn-primary btn-xl xs-mr-20 sm-mr-50">Return to subject shelf</router-link> <router-link :to="{name: 'importer'}" class="import-link">Import another file</router-link>
              </div>
            </div>
            <div class="row ptb-50 xs-pt-0" v-if="showSummary">
              <div class="col-xs-12">
                <h3>Import summary</h3>
                <div class="summary-row">
                  <strong class="summary-name pull-left">Subjects added:</strong> <span class="pull-left">{{subjects_added}}</span>
                  <div class="clearfix"></div>
                </div>
                <div class="summary-row">
                  <strong class="summary-name pull-left">Subjects skipped:</strong> <span class="pull-left">{{subjects_skipped}}</span>
                  <div class="clearfix"></div>
                </div>
                <div class="summary-row">
                  <strong class="summary-name pull-left">Chapters added:</strong> <span class="pull-left">{{chapters_added}}</span>
                  <div class="clearfix"></div>
                </div>
                <div class="summary-row">
                  <strong class="summary-name pull-left">Chapters skipped:</strong> <span class="pull-left">{{chapters_skipped}}</span>
                  <div class="clearfix"></div>
                </div>
                <div class="summary-row">
                  <strong class="summary-name pull-left">Micronotes added:</strong> <span class="pull-left">{{micronotes_added}}</span>
                  <div class="clearfix"></div>
                </div>
                <div class="summary-row">
                  <strong class="summary-name pull-left">Micronotes skipped:</strong> <span class="pull-left">{{micronotes_skipped}}</span>
                  <div class="clearfix"></div>
                </div>
              </div>
            </div>
          </PanelBody>
        </Panel>
      </div><!-- /.div -->
    </div><!-- /.div -->
  </div><!-- /.div -->


</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  components: {
    
  },

  created() {
    
  },

  methods: {
    ...mapActions({
      
    }),
  },


  computed: {
    ...mapGetters({
    }),
    showSummary() {
      if (this.chapters_added > 0 ||
        this.chapters_skipped > 0 ||
        this.micronotes_added > 0 ||
        this.micronotes_skipped > 0 ||
        this.subjects_added > 0 ||
        this.subjects_skipped > 0) {
        return true;
      }

      return false;
    }
  },

  data() {
    return {
      chapters_added: this.$route.params.chapters_added,
      chapters_skipped: this.$route.params.chapters_skipped,
      micronotes_added: this.$route.params.micronotes_added,
      micronotes_skipped: this.$route.params.micronotes_skipped,
      subjects_added: this.$route.params.subjects_added,
      subjects_skipped: this.$route.params.subjects_skipped,
    }
  },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .ptb-50 {padding:50px 0px;}
  .summary-row {padding:5px 10px;background:#EEEEEE;width:200px;}
  .summary-row:nth-child(even) {background:#DDDDDD;}
  .summary-name {width:150px;}
</style>



// WEBPACK FOOTER //
// MicroNoteImportSuccess.vue?6f9b301e